/**
 * UTM 全局捕获 — 从 URL 解析并持久化到 sessionStorage
 * 页面加载时立即执行，供其他脚本（如 footer.js）读取后上报 Klaviyo
 */
(function () {
  var STORAGE_KEY = 'ive_utm';
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  var params = new URLSearchParams(window.location.search);
  var utm = {};

  UTM_KEYS.forEach(function (key) {
    var val = params.get(key);
    if (val) utm[key] = val;
  });

  // 当前 URL 有 UTM 参数时存入 sessionStorage（覆盖旧值）
  if (Object.keys(utm).length > 0) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(utm));
  }

  // 暴露到全局，供 footer.js 等脚本读取
  var stored = sessionStorage.getItem(STORAGE_KEY);
  window.iveUtm = stored ? JSON.parse(stored) : {};
})();
